import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Lägg till ny", -1)
const _hoisted_2 = { autocomplete: "off" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "row mb-3 mt-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-firstName",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Förnamn:", -1)
const _hoisted_6 = { class: "col-md-4 col-xs-12" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-lastName",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Efternamn:", -1)
const _hoisted_8 = { class: "col-md-4 col-xs-12" }
const _hoisted_9 = { class: "row mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-personalIdentityNumber",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Personnummer:", -1)
const _hoisted_11 = { class: "col-md-10 col-xs-12" }
const _hoisted_12 = { class: "row mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-address",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Adress:", -1)
const _hoisted_14 = { class: "col-md-10 col-xs-12" }
const _hoisted_15 = { class: "row mb-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-address2",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Adress 2:", -1)
const _hoisted_17 = { class: "col-md-10 col-xs-12" }
const _hoisted_18 = { class: "row mb-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-postalCode",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Postnummer:", -1)
const _hoisted_20 = { class: "col-md-4 col-xs-12" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-city",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Ort:", -1)
const _hoisted_22 = { class: "col-md-4 col-xs-12" }
const _hoisted_23 = { class: "row mb-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-phone",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Hemtelefon:", -1)
const _hoisted_25 = { class: "col-md-4 col-xs-12" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-mobile",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Mobiltelefon:", -1)
const _hoisted_27 = { class: "col-md-4 col-xs-12" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_29 = { class: "row mb-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-relativeName",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Anhörig namn:", -1)
const _hoisted_31 = { class: "col-md-4 col-xs-12" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-relativeRelation",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Relation:", -1)
const _hoisted_33 = { class: "col-md-4 col-xs-12" }
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-relativePhone",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Anhörig telefon:", -1)
const _hoisted_37 = { class: "col-md-10 col-xs-12" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_39 = { class: "row mb-3" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-bankClearing",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Clearingnummer:", -1)
const _hoisted_41 = { class: "col-md-4 col-xs-12" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-bankAccount",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Bankkonto:", -1)
const _hoisted_43 = { class: "col-md-4 col-xs-12" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_45 = { class: "row mb-3" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-campaign",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Kampanj:", -1)
const _hoisted_47 = { class: "col-md-10 col-xs-12" }
const _hoisted_48 = ["value", "disabled"]
const _hoisted_49 = { class: "row mb-3" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-employmentDate",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Anställningsdatum:", -1)
const _hoisted_51 = { class: "col-md-4 col-xs-12" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-employmentForm",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Anställningsform:", -1)
const _hoisted_53 = { class: "col-md-4 col-xs-12" }
const _hoisted_54 = ["value"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_56 = { class: "row mb-3" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-info",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Övrig info:", -1)
const _hoisted_58 = { class: "col-md-10 col-xs-12" }
const _hoisted_59 = {
  key: 0,
  class: "row"
}
const _hoisted_60 = { class: "col" }
const _hoisted_61 = {
  class: "alert alert-success alert-dismissible fade show",
  role: "alert"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "alert",
  "aria-label": "Close"
}, null, -1)
const _hoisted_63 = { class: "row" }
const _hoisted_64 = { class: "col d-grid" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_messages = _resolveComponent("messages")!
  const _component_FormInputPersonalIdentityNumber = _resolveComponent("FormInputPersonalIdentityNumber")!
  const _component_FormInputPostalCode = _resolveComponent("FormInputPostalCode")!
  const _component_FormInputPhoneNumber = _resolveComponent("FormInputPhoneNumber")!
  const _component_FormInputDate = _resolveComponent("FormInputDate")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "float-end btn btn-outline-dark",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearForm && _ctx.clearForm(...args)))
    }, "Rensa formulär"),
    _hoisted_1,
    _createVNode(_component_messages, { ref: "errorHandler" }, null, 512),
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("fieldset", {
        disabled: _ctx.loadingCampaigns || _ctx.loadingEmploymentForms || _ctx.loadingRelationTypes
      }, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              ref: "formFirstName",
              class: "form-control",
              id: "form-firstName",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.firstName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.formData.firstName]
            ])
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "form-lastName",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.lastName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.formData.lastName]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_FormInputPersonalIdentityNumber, {
              modelValue: _ctx.formData.personalIdentityNumber,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.personalIdentityNumber) = $event)),
              id: "form-personalIdentityNumber"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "form-address",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.address) = $event))
            }, null, 512), [
              [_vModelText, _ctx.formData.address]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "form-address2",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.address2) = $event))
            }, null, 512), [
              [_vModelText, _ctx.formData.address2]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_FormInputPostalCode, {
              modelValue: _ctx.formData.postalCode,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.postalCode) = $event)),
              id: "form-postalCode"
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "form-city",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.city) = $event))
            }, null, 512), [
              [_vModelText, _ctx.formData.city]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_FormInputPhoneNumber, {
              modelValue: _ctx.formData.phoneHome,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.phoneHome) = $event)),
              id: "form-phone"
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_FormInputPhoneNumber, {
              modelValue: _ctx.formData.phoneMobile,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.phoneMobile) = $event)),
              id: "form-mobile"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _hoisted_28,
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "form-relativeName",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.relativeName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.formData.relativeName]
            ])
          ]),
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _withDirectives(_createElementVNode("select", {
              id: "form-relativeRelation",
              class: "form-select",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.relativeRelation) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relationTypes, (rt) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: rt.id,
                  value: rt
                }, _toDisplayString(rt.name), 9, _hoisted_34))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.formData.relativeRelation]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_FormInputPhoneNumber, {
              modelValue: _ctx.formData.relativePhone,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.relativePhone) = $event)),
              id: "form-relativePhone"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _hoisted_38,
        _createElementVNode("div", _hoisted_39, [
          _hoisted_40,
          _createElementVNode("div", _hoisted_41, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "form-bankClearing",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.bankClearing) = $event))
            }, null, 512), [
              [_vModelText, _ctx.formData.bankClearing]
            ])
          ]),
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "form-bankAccount",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.bankAccount) = $event))
            }, null, 512), [
              [_vModelText, _ctx.formData.bankAccount]
            ])
          ])
        ]),
        _hoisted_44,
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _createElementVNode("div", _hoisted_47, [
            _withDirectives(_createElementVNode("select", {
              id: "form-campaign",
              class: "form-select",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.campaign) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaigns, (c) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: c.id,
                  value: c,
                  disabled: !c.active
                }, _toDisplayString(c.id) + " : " + _toDisplayString(c.name), 9, _hoisted_48))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.formData.campaign]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _hoisted_50,
          _createElementVNode("div", _hoisted_51, [
            _createVNode(_component_FormInputDate, {
              modelValue: _ctx.formData.employmentDate,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.employmentDate) = $event)),
              id: "form-employmentDate"
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_52,
          _createElementVNode("div", _hoisted_53, [
            _withDirectives(_createElementVNode("select", {
              id: "form-employmentForm",
              class: "form-select",
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.employmentForm) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employmentForms, (empForm) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: empForm.id,
                  value: empForm
                }, _toDisplayString(empForm.name), 9, _hoisted_54))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.formData.employmentForm]
            ])
          ])
        ]),
        _hoisted_55,
        _createElementVNode("div", _hoisted_56, [
          _hoisted_57,
          _createElementVNode("div", _hoisted_58, [
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control",
              id: "form-info",
              rows: "3",
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.info) = $event))
            }, null, 512), [
              [_vModelText, _ctx.formData.info]
            ])
          ])
        ]),
        _createVNode(_component_messages, { ref: "saveNewEmployeeErrorHandler" }, null, 512),
        (_ctx.savingNewEmployeeSuccessId > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createTextVNode(" Nyanställd skapad. "),
                  _createVNode(_component_router_link, {
                    to: { name: 'EditNewEmployees', params: { newEmployeeId: _ctx.savingNewEmployeeSuccessId } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("[ Visa ]")
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    to: { name: 'AddNewEmployeeAccounts', params: { newEmployeeId: _ctx.savingNewEmployeeSuccessId } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("[ Skapa konto ]")
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _hoisted_62
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary",
              onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.saveNewEmployee()), ["prevent"])),
              disabled: _ctx.savingNewEmployee
            }, [
              (!_ctx.savingNewEmployee)
                ? (_openBlock(), _createElementBlock("span", _hoisted_66, "Spara"))
                : (_openBlock(), _createBlock(_component_fa_icon, {
                    key: 1,
                    icon: "spinner"
                  }))
            ], 8, _hoisted_65)
          ])
        ])
      ], 8, _hoisted_3)
    ])
  ], 64))
}